import { render, staticRenderFns } from "./single-data-card.vue?vue&type=template&id=ac7b0e30"
import script from "./single-data-card.vue?vue&type=script&lang=js"
export * from "./single-data-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports